var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchCircleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#181818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.32031,
    y: 8.32129,
    width: 63.3571,
    height: 63.3571,
    rx: 31.6786,
    stroke: "#EEEEEE",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5703,
    y: 12.5713,
    width: 54.8571,
    height: 54.8571,
    rx: 27.4286,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6654 38.6669C50.3393 36.3206 49.2508 34.1465 47.5675 32.4796C45.8843 30.8127 43.6997 29.7455 41.3503 29.4423C39.0008 29.1392 36.6169 29.6169 34.5656 30.8019C32.5144 31.9869 30.9097 33.8135 29.9987 36.0003M29.332 30.6669V36.0003H34.6654M29.332 41.3336C29.6581 43.68 30.7466 45.854 32.4298 47.5209C34.1131 49.1878 36.2977 50.255 38.6471 50.5582C40.9966 50.8613 43.3805 50.3836 45.4318 49.1986C47.483 48.0136 49.0877 46.187 49.9987 44.0002M50.6654 49.3336V44.0002H45.332M38.6654 40.0002C38.6654 40.3539 38.8058 40.693 39.0559 40.9431C39.3059 41.1931 39.6451 41.3336 39.9987 41.3336C40.3523 41.3336 40.6915 41.1931 40.9415 40.9431C41.1916 40.693 41.332 40.3539 41.332 40.0002C41.332 39.6466 41.1916 39.3075 40.9415 39.0574C40.6915 38.8074 40.3523 38.6669 39.9987 38.6669C39.6451 38.6669 39.3059 38.8074 39.0559 39.0574C38.8058 39.3075 38.6654 39.6466 38.6654 40.0002Z",
    stroke: "#00332D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCircleDark);
export default __webpack_public_path__ + "static/media/switch-circle-dark.baeaed0d160c0e80684f5990804ab631.svg";
export { ForwardRef as ReactComponent };